import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { marker as extractTranslation } from '@colsen1991/ngx-translate-extract-marker';
import { TranslateService } from '@ngx-translate/core';
import { AppRoleKey } from '@nk/data-entities-lib';
import { NO_ACCESS_ROUTE } from '@nk/utils-lib';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { AppRoleService } from '../services/app-role.service';
import { hasAllRequiredRoles } from '../utils/role.utils';

export function roleAccessGuard(requiredRoles: AppRoleKey[]): CanActivateFn {
  return (route, state): Observable<boolean> => {
    const router = inject(Router);
    const appRoleService = inject(AppRoleService);
    const translateService = inject(TranslateService);

    return appRoleService.activeAppRoleDimsCache.get().pipe(
      first(),
      map((roleDims) => {
        if (Array.isArray(requiredRoles) && hasAllRequiredRoles(roleDims.flags, requiredRoles)) {
          return true;
        }
        const title = translateService.instant(extractTranslation('identity.roles.no_access_modal.title')) as string;
        const message = translateService.instant(extractTranslation('identity.roles.no_access_modal.message'), {
          url: state.url,
        }) as string;
        void router.navigate([NO_ACCESS_ROUTE], { queryParams: { title, message } });
        return false;
      }),
    );
  };
}
